import { useContext } from "react";
import { AnimalHandlingAlertContext } from "../../contexts/animalHandlingAlertContext";

const useAnimalHandlingAlertContext = () => {
  const value = useContext(AnimalHandlingAlertContext);
  return value;
};

export default useAnimalHandlingAlertContext;
